// src/pages/research/Research.config.ts

/**
 * Interface for paper translations
 */
interface PaperTranslations {
    title: string;
    description: string;
}

/**
 * Interface for research paper configuration
 */
interface ResearchPaper {
    id: string;
    status: 'published' | 'preprint' | 'inreview';
    doi: string;
    authors: string[];
    date: string;
    translations: {
        en: PaperTranslations;
        de: PaperTranslations;
    };
}

/**
 * Configuration data for research papers
 */
export const RESEARCH_PAPERS: ResearchPaper[] = [
    {
        id: 'emergency-game',
        status: 'published',
        doi: 'https://doi.org/10.1186/s12909-024-06056-z',
        authors: [
            "Alexandra Aster",
            "Christopher Hütt",
            "Caroline Morton",
            "Maxwell Flitton",
            "Matthias Carl Laupichler",
            "Tobias Raupach"
        ],
        date: "February 2024",
        translations: {
            en: {
                title: "Development and evaluation of an emergency department serious game for undergraduate medical students",
                description: "This paper describes the development and evaluation of a serious game designed to teach emergency department management to undergraduate medical students."
            },
            de: {
                title: "Entwicklung und Evaluierung eines Notaufnahme-Serious-Games für Medizinstudierende",
                description: "Diese Arbeit beschreibt die Entwicklung und Evaluierung eines Serious Games zur Vermittlung des Notaufnahmemanagements an Medizinstudierende."
            }
        }
    },
    {
        id: 'chatbot',
        status: 'published',
        doi: 'https://advancesinsimulation.biomedcentral.com/articles/10.1186/s41077-025-00341-7',
        authors: [
            "Alexandra Aster",
            "Arietta Lotz",
            "Tobias Raupach"
        ],
        date: "March 2025",
        translations: {
            en: {
                title: "Theoretical background of the game design element “chatbot” in serious games for medical education",
                description: "This paper investigates whether open chatbots in medical education serious games better support students' autonomy (based on self-determination theory) compared to constrained chat systems, finding that while open chatbots encouraged more exploration and led to better diagnostic accuracy, they did not significantly increase students' subjective feelings of autonomy."
            },
            de: {
                title: "Theoretischer Hintergrund des Spieldesign-Elements 'Chatbot' in Serious Games für die medizinische Ausbildung",
                description: "Diese Studie untersucht, ob offene Chatbots in Serious Games für die medizinische Ausbildung die Autonomie der Studierenden (basierend auf der Selbstbestimmungstheorie) besser unterstützen als eingeschränkte Chat-Systeme, und stellt fest, dass offene Chatbots zwar mehr Erkundung förderten und zu besserer diagnostischer Genauigkeit führten, jedoch nicht zu einer signifikanten Steigerung des subjektiven Autonomiegefühls bei den Studierenden beitrugen."
            }
        }
    },
    // Add more papers here as needed
];